module.exports = __webpack_public_path__ + "static/media/delete.853ba4a0.svg";